module.exports = __webpack_public_path__ + "static/media/burger.0a668f22.svg";